<template>
  <div >
    <b-card>
      <form v-on:submit.prevent="formSubmitted" enctype="multipart/form-data">
      <!-- accoint details tab -->
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Job Details
                </h5>
                
                <small class="text-muted" v-if="form.jobId">
                  Error : {{ form.jobId }}
                </small>
              </b-col>
              
              <!-- Form Draft Persistence UI -->
              <b-col
                cols="12"
                class="mb-2"
                v-if="hasFormDraft || lastSavedTimestamp"
              >
                <b-alert variant="info" show class="mb-0">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <i class="fas fa-save mr-1"></i>
                      <span v-if="lastSavedTimestamp">
                        Draft saved {{ formatTimestamp(lastSavedTimestamp) }}
                      </span>
                      <span v-else-if="hasFormDraft">
                        Draft available
                      </span>
                    </div>
                    <div>
                      <b-button 
                        v-if="hasFormDraft && isFormEmpty" 
                        size="sm" 
                        variant="outline-primary" 
                        @click="restoreFormDraft"
                        class="mr-2"
                      >
                        <i class="fas fa-undo mr-1"></i>
                        Restore Draft
                      </b-button>
                      <b-button 
                        v-if="hasFormDraft" 
                        size="sm" 
                        variant="outline-danger" 
                        @click="clearFormDraft"
                      >
                        <i class="fas fa-times mr-1"></i>
                        Clear Draft
                      </b-button>
                    </div>
                  </div>
                </b-alert>
              </b-col>
              
              <!-- Auto-save Toggle -->
              <b-col
                cols="12"
                class="mb-2"
              >
                <b-form-checkbox
                  v-model="autoSaveEnabled"
                  switch
                  @change="toggleAutoSave"
                >
                  <small>Auto-save form data (saves automatically as you type)</small>
                </b-form-checkbox>
              </b-col>

              <b-col
                md="4"
                xl="4"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Skill *"
                  label-for="jobTitle"
                >
                    <b-form-input
                      id="job-title"
                      v-model="form.jobTitle"
                      class="text-capitalize"
                      type="text"
                      placeholder="FPNA/Python Developer/Java Developer"
                      ref="title"
                    />
                    <small v-if="!form.jobTitle || this.form.jobTitle.includes('_') || this.form.jobTitle.includes(this.form.poc.split(' ')[0])" class="text-danger">{{ error.title }}</small>
                  
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Position Type *"
                  label-for="position"
                >
                  
                    <b-form-group ref="position">
                      <v-select
                        v-model="form.type"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="jobTypeOptions"
                        :reduce="(option) => option.title"
                      />
                    </b-form-group>
                  <small v-if="!form.type"  class="text-danger">{{ error.type }}</small>
                  
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Role"
                  label-for="jobRole"
                >
                    <b-form-input
                      id="job-role"
                      v-model="form.role"
                      class="text-capitalize"
                      type="text"
                      placeholder="Job Role"
                      ref="title"
                    />
                    
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Band/Job Level"
                  label-for="jobBand"
                >
                    <b-form-input
                      id="job-band"
                      v-model="form.jobBand"
                      class="text-capitalize"
                      type="text"
                      placeholder="Job Band"
                      ref="title"
                    />
                   
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Client *"
                  label-for="client"
                >
                  
                    <b-form-group ref="client">
                      <v-select
                        v-model="form.clientSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="clients"
                        
                      />
                    </b-form-group>
                    
                  <small v-if="!form.clientSelected"  class="text-danger">{{ error.client }}</small>
                  
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isKPMGRPOClient"
              >
                <b-form-group
                  label="Business *"
                  label-for="business"
                >
                    <b-form-group ref="business">
                      <v-select
                        v-model="form.business"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="businessOptions"
                        
                        placeholder="Select Business"
                      />
                    </b-form-group>
                  <small v-if="!hasSelectedBusiness" class="text-danger">{{ error.business }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isKPMGRPOClient && hasSelectedBusiness && filteredSubBusinessOptions.length > 0"
              >
                <b-form-group
                  label="Sub Business"
                  label-for="subBusiness"
                >
                    <b-form-group ref="subBusiness">
                      <v-select
                        v-model="form.subBusiness"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="filteredSubBusinessOptions"
                        multiple
                        placeholder="Select Sub Business"
                      />
                    </b-form-group>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Domain *"
                  label-for="jobDomain"
                >
                
                  <b-form-group>
                    <v-select
                      v-model="form.domainSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="domains"
                      ref="domain"
                      style="overflow-x: visible"
                    />
                  </b-form-group>
                  <small v-if="!form.domainSelected" class="text-danger">{{ error.domain }}</small>
                
                </b-form-group>
              </b-col>

              <!-- Job Function for Reliance & Reliance RPO -->
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Job Function *"
                  label-for="jobFunction"
                >
                  <b-form-group ref="jobFunction">
                    <v-select
                      v-model="form.jobFunction"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="jobFunctionOptions"
                      placeholder="Select Job Function"
                    />
                  </b-form-group>
                  <small v-if="isRelianceClient && !form.jobFunction" class="text-danger">{{ error.jobFunction }}</small>
                </b-form-group>
              </b-col>
              <!-- Drive Dates for Reliance RPO (multi-date) -->
              <b-col
                md="4"
                xl="4"
                xs="12"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Drive Date(s)"
                  label-for="driveDates"
                >
                  <div
                    v-for="(d, i) in form.driveDates"
                    :key="i"
                    class="d-flex align-items-center mb-50"
                    style="gap:6px;"
                  >
                    <b-form-input
                      :value="d"
                      type="date"
                      @change="(val) => { $set(form.driveDates, i, val); updateDriveName() }"
                    />
                    <b-button
                      variant="flat-danger"
                      size="sm"
                      class="btn-icon"
                      @click="removeDriveDate(i)"
                    >
                      <feather-icon icon="XIcon" size="14" />
                    </b-button>
                  </div>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="mt-50"
                    @click="addDriveDate"
                  >
                    <feather-icon icon="PlusIcon" size="13" class="mr-25" />Add Date
                  </b-button>
                </b-form-group>
              </b-col>

              <!-- Drive Name for Reliance RPO (auto-generated, manually overridable) -->
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Drive Name *"
                  label-for="driveName"
                >
                  <small class="text-muted d-block mb-25" v-if="computedDriveName">
                    Auto: {{ computedDriveName }}
                  </small>
                  <b-form-input
                    v-model="form.driveName"
                    placeholder="Drive name (auto-filled)"
                    type="text"
                    ref="driveName"
                    disabled
                  />
                  <small v-if="error.driveName" class="text-danger">{{ error.driveName }}</small>
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Position Submission Date"
                  label-for="positionSubmissionDate"
                >
                  <b-form-input
                    v-model="form.positionSubmissionDate"
                    placeholder="Enter Position Submission Date"
                    type="date"
                    ref="positionSubmissionDate"
                  />
                  <small v-if="error.positionSubmissionDate" class="text-danger">{{ error.positionSubmissionDate }}</small>
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="4"
                class="mb-1"
              >
                <b-form-group
                  label="Point Of Contact *"
                  label-for="poc"
                >
                    <b-form-input
                      id="poc"
                      v-model="form.poc"
                      class="text-capitalize"
                      type="text"
                      placeholder="Name of PoC"
                      :state="pocState"
                    />
                    <small v-if="this.error.poc" class="text-danger"> {{ error.poc }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="form.type === 'Contractual'"
              >
                
                <b-form-group
                  label="Payroll *"
                  label-for="payroll"
                  
                >
                    <v-select
                      v-model="form.payroll"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="payrollOptions"
                      ref="payroll"
                      style="overflow-x: visible"
                      :reduce="(option) => option.title"
                    />
                    <small v-if="this.error.payroll" class="text-danger"> {{ error.payroll }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Category *"
                  label-for="category"
                  
                >
                    <v-select
                      v-model="form.category"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="categoryOptions"
                      ref="category"
                      style="overflow-x: visible"
                      :reduce="(option) => option.title"
                    />
                    <small v-if="this.error.category" class="text-danger"> {{ error.category }}</small>
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Vertical *"
                  label-for="vertical"
                  
                >
                    <v-select
                      v-model="form.vertical"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="verticalOptions"
                      ref="vertical"
                      style="overflow-x: visible"
                      :reduce="(option) => option.title"
                    />
                    <small v-if="this.error.vertical" class="text-danger"> {{ error.vertical }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
              <b-form-group
                  label="Target Date *"
                  label-for="targetDate"
                  
                >
                    <b-form-datepicker
                      id="targetDate"
                      v-model="form.targetDate"
                      class="mb-1"
                    />
                  
                </b-form-group>
              </b-col>  
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Notice Period *"
                  label-for="noticePeriod"
                >
                  <v-select
                      id="notice-period"
                      v-model="form.noticePeriod"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="noticePeriod"
                      ref="np"
                    />
                    <!--<b-form-input
                      id="notice-period"
                      v-model="form.noticePeriod"
                      type="number"
                      ref="np"
                      placeholder="Number of Days"
                    />-->
                    <small v-if="!form.noticePeriod" class="text-danger">{{ error.noticePeriod }}</small>
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="No of Positions *"
                  label-for="noOfPostion"
                >
                  
                    <b-form-input
                      id="noOfPositions"
                      v-model="form.noOfPositions"
                      type="number"
                      ref="nop"
                      placeholder="Number of Vacancies"
                    />
                    <small v-if="!form.noOfPositions" class="text-danger">{{ error.noOfPosition }}</small>
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Min Experience *"
                  label-for="min-exp"
                >
                    <b-form-input
                      id="min-exp"
                      v-model="form.minExp"
                      type="text"
                      inputmode="decimal"
                      placeholder="Exp in years"
                      ref="minexp"
                      @input="onOneDecimalInput('minExp', $event)"
                      @blur="onOneDecimalBlur('minExp')"
                    />
                    <small v-if="error.minExp" class="text-danger">{{ error.minExp }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 1.5)</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Max Experience *"
                  label-for="max-exp"
                >                
                    <b-form-input
                      id="max-exp"
                      v-model="form.maxExp"
                      type="text"
                      inputmode="decimal"
                      ref="maxexp"
                      placeholder="Exp in years"
                      @input="onOneDecimalInput('maxExp', $event)"
                      @blur="onOneDecimalBlur('maxExp')"
                    />
                    <small v-if="error.maxExp" class="text-danger">{{ error.maxExp }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 1.5)</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Minimum CTC *"
                  label-for="minCTC"
                >
                    <b-form-input
                      id="min-ctc"
                      v-model="form.minCTC"
                      type="text"
                      inputmode="decimal"
                      ref="minctc"
                      :placeholder="form.type === 'Contractual' && form.vertical === 'Infra Industry' && form.category === 'Blue Collar' && form.payroll === 'Sattva Payroll' ? 'Monthly salary': 'Enter Amount in lacs'"
                      @input="onOneDecimalInput('minCTC', $event)"
                      @blur="onOneDecimalBlur('minCTC')"
                    />
                    <small v-if="error.minCTC" class="text-danger">{{ error.minCTC }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 10.5)</small>
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Maximum CTC *"
                  label-for="minCTC"
                >
                  
                    <b-form-input
                      id="max-ctc"
                      v-model="form.maxCTC"
                      type="text"
                      inputmode="decimal"
                      ref="maxctc"
                      :placeholder="form.type === 'Contractual' && form.vertical === 'Infra Industry' && form.category === 'Blue Collar' && form.payroll === 'Sattva Payroll' ? 'Monthly salary': 'Enter Amount in lacs'"
                      @input="onOneDecimalInput('maxCTC', $event)"
                      @blur="onOneDecimalBlur('maxCTC')"
                    />
                    <small v-if="error.maxCTC" class="text-danger">{{ error.maxCTC }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 10.5)</small>
                 
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Offered Position"
                  label-for="offeredPosition"
                >
                  
                    <b-form-input
                      id="offeredPosition"
                      v-model="form.offeredPosition"
                      type="text"
                      placeholder="Offered Position Name"
                    />
                    <!-- <small v-if="!form.noOfPositions" class="text-danger">{{ error.noOfPosition }}</small> -->
                 
                </b-form-group>
              </b-col>
              
              <b-col
                md="6"
                xl="6"
                xs="6"
                class="mb-1"
              >
              <ValidationProvider name="Desired Skills" rules="required|desiredSkills" v-slot="{ errors }">
                <b-form-group
                  label="Desired/Mandatory Skills *"
                  label-for="desiredSkills"
                >
                  <b-form-input
                    v-model="form.skills"
                    placeholder="Min. 3 skills, comma separated (e.g. React, Node.js, MongoDB)"
                    type="text"
                    ref="skill"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                  <small v-if="!form.skills" class="text-danger">{{ error.skills }}</small>
                
                </b-form-group>
              </ValidationProvider>
              </b-col>
              
              
            </b-row>
          
        
          <div>
            
            <b-row>
              <b-col
                md="6"
                xl="6"
                xs="6"
                class="mb-1"
              >
              <h5 class="mb-1 mt-1">
              Account Manager
            </h5>
                <b-form-group
                  label="Account Mgr/Team Lead *"
                  label-for="accountMgr"
                >
                  <v-select
                      v-model="form.mgrSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="accountMgr"
                      ref="accMgr"
                    />
                  <small v-if="!form.mgrSelected" class="text-danger">{{ error.accMgr }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="6"
                xs="6"
                class="mb-1"
              >
              <h5 class="mb-1 mt-1">
              Sourcer
            </h5>
                <b-form-group
                  label="Sourcer *"
                  label-for="sourcer"
                >
                  <v-select
                      v-model="form.sourcerSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      multiple
                      :options="recruiters"
                      :close-on-select="false"
                      ref="sourcer"
                    />
                  <small v-if="!form.sourcerSelected" class="text-danger">{{ error.sourcer }}</small>
                </b-form-group>
              </b-col>
            </b-row>
          </div>  
          <div>
            <h5 class="mb-1 mt-1">
              Location & Recruiters
            </h5>
            <b-row>
            <b-col
              md="6"
              xl="6"
              xs="6"
              class="mb-2"
            >
              <b-form-group
                label="City *"
                label-for="city"
              >
                  
                  <b-form-group>
                    <v-select
                      v-model="form.citySelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :close-on-select="false"
                      multiple
                      :options="cities"
                      ref="city"
                    />
                  </b-form-group>
                  <small v-if="!form.citySelected" class="text-danger">{{ error.city }}</small>
               
              </b-form-group>
            </b-col>  
            <b-col
              md="6"
              xl="6"
              xs="6"
              class="mb-1"
            > 
            
              <b-form-group
                label="Recruiters *"
                label-for="recruiters"
              >
                <v-select
                  v-model="form.recruitersSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  multiple
                  :close-on-select="false"
                  label="title"
                  :options="recruiters"
                  ref="recruit"
                />
              <small v-if="!form.recruitersSelected" class="text-danger">{{ error.recruiter }}</small>
              
              </b-form-group>
              
              
            </b-col>
          </b-row>
          </div>
          <div>
            <h5 class="mb-1 mt-1">
              Job Description *
            </h5>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                
                <!--<small class="text-muted">Enter Job Description</small>-->
              </b-col>
              <b-col
                cols="12"
                class="mb-2"
              >
                <quill-editor
                  v-model="form.jdContent"
                  :options="snowOption"
                  ref="jd"

                />
                <small class="text-danger" v-if="!form.jdContent || form.jdContent.length < 200 || !validateJDContent(form.jdContent)">{{ error.jd || 'Job description should be of atleast 200 characters' }}</small>
              </b-col>
              <b-col
                cols="6"
                xs="12"
                class="mb-2"
              >
                <label for="textarea-default">Recruiter Notes </label>
                <b-form-textarea
                  id="textarea-default"
                  v-model="form.notes"
                  placeholder="Add Notes"
                  rows="3"
                />
                <!-- <small class="text-danger">{{ error.notes }}</small> -->
              </b-col>
              <b-col
                cols="6"
                xs="12"
                class="mb-2 mt-3"
              >
                <div>
                  
                  <!-- <div style="float:left">
                    <b-card-text class="mb-1">
                      Is JD Available?
                    </b-card-text>
                    <b-form-checkbox v-model="checked" name="check-button" switch>
                      
                    </b-form-checkbox>
                  </div> -->
                </div>
                <b-form-file 
                  name="jdFile"
                  placeholder="ADD Job Description file here... *"
                  drop-placeholder="Drop Job Description file here..."
                  @change='openFile'
                  type="file"
                  v-model="form.file"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                />
                <!-- <b-form-file v-if="checked"
                  name="jdFile"
                  placeholder="ADD Job Description file here..."
                  drop-placeholder="Drop Job Description file here..."
                  @change='openFile'
                  type="file"
                  v-model="form.file"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                /> -->
                <small class="text-danger">{{ error.file }}</small>
                <small v-if="form.file && form.file.size > 1600000" class="text-danger"> File Size Should be less than 1.5 mb </small>
              </b-col>

            </b-row>
          </div>
          
          <div>
            <b-row>
              <b-col
              md="12"
              xl="12"
              xs="12"
              class="mb-2"
              >
              <b-button variant="relief-success" value="submit" id="submit" type="submit" width="100%" :disabled="isSubmitting">
                {{ isSubmitting ? 'Submitting...' : 'Submit' }}
              </b-button>
              
              </b-col>
            </b-row>
          </div>

      </form>
    </b-card>
  </div>
  <!-- <div v-else>
    <b-card>
      <b-card-text>
        You are not authorized to create jobs.
      </b-card-text>
    </b-card>
  </div> -->
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', required);
extend('desiredSkills', {
  validate(value) {
    const skills = value.split(',').map(s => s.trim()).filter(s => s.length > 0)
    return skills.length >= 3
  },
  message: 'At least 3 skills are required, separated by commas (e.g. React, Node.js, MongoDB).',
});
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'
import moment from 'moment'
import JobService from '../../../services/job-service'
import NoteService from '../../../services/note-service'
import UserService from '@/services/user-service'
import { sendPushToUserId, buildJobDeepLink } from '@/utils/fcm-push'
import jobTimelineService from '@/services/job-timeline'
import clientService from '@/services/client-service'
import domainService from '@/services/domain-service'
import adminConfigService from '@/services/admin-config-service'
//import { BFormCheckbox } from 'bootstrap-vue'

import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
  BFormCheckbox,
  BAlert
} from 'bootstrap-vue'
import locationService from '@/services/location-service'
//import { required, email } from '@validations'
// import { codeIcon } from './code'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    quillEditor,
    BFormFile,
    BFormTextarea,
    BFormInvalidFeedback,
    BAlert,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      form:{
        jobId: '',
        id: '',
        jobTitle: '',
        jobBand: '',
        role: '',
        clientSelected: '',
        domainSelected: '',
        poc: '',
        targetDate: '',
        minExp: '',
        maxExp: '',
        minCTC: '',
        maxCTC: '',
        noticePeriod: '',
        noOfPositions: '',
        skills: '',
        skillsSelected: '',
        citySelected: '',
        recruitersSelected: '',
        jdContent: '',
        notes: '',
        file: null,
        mgrSelected: '',
        sourcerSelected: '',
        type: '',
        category: '',
        vertical: '',
        payroll: '',
        business: [],
        subBusiness: [],
        jobFunction: null,
        offeredPosition: '',
        driveName: '',
        driveDates: [],
        positionSubmissionDate: '',
      },
      promiseFulfilled: false,
      promiseRejected: false,
      snowOption: {
        theme: 'snow',
      },
      error: {
        title: '',
        client: '',
        domain: '',
        minExp: '',
        maxExp: '',
        minCTC: '',
        maxCTC: '',
        noticePeriod: '',
        noOfPositions: '',
        skills: '',
        city: '',
        recruiter: '',
        sourcer: '',
        jd: '',
        accMgr: '',
        notes: '',
        type: '',
        payroll: '',
        category: '',
        vertical: '',
        jobFunction: '',
        driveName: '',
        positionSubmissionDate: '',

      },
      clients: [],
      domains:[],
      recruiters: [],
      accountMgr: [],
      sourcer: [],
      cities: [],
      fcmToken: '',
      noticePeriod: [{title: "Immediate", value: 0}, {title: "0-15", value: 15}, {title: "0-30", value: 30},{title: "0-45", value: 45},{title: "0-60", value: 60}, {title: "0-90", value: 90}],
      checked: true,
      jobTypeOptions: [{title: "Full Time"}, {title: "Contractual"}, {title: "Fixed Term"}, {title: "Cost Plus"}],
      payrollOptions: [{title: "Client Payroll"}, {title: "Sattva Payroll"}, {title: "Third Party"}],
      categoryOptions: [{title: "White Collar"}, {title: "Blue Collar"}],
      verticalOptions: [{title: "Service Industry"}, {title: "Infra Industry"}],
      businessOptions: [],
      subBusinessOptions: [],
      jobFunctionOptions: [],
      // Form persistence
      formDraftKey: 'addJobFormDraft',
      autoSaveEnabled: true,
      autoSaveDebounceTimer: null,
      lastSavedTimestamp: null,
      isRestoring: false, // Flag to prevent auto-save during restore
      isSubmitting: false, // Prevents duplicate submissions while a request is in flight
      dropdownsPollTimer: null,

      //type: null
    }
  },
  mounted() {
    adminConfigService.getJobsDropdownList().then(res=>{
        this.jobStatusOptions = res.data.data.jobStatusList
        this.jobTypeOptions = res.data.data.jobTypeList
        this.categoryOptions = res.data.data.categoryList
        this.payrollOptions = res.data.data.payrollList
        this.verticalOptions = res.data.data.verticalList
    })
    
    // Restore form draft after dropdowns are loaded
    this.$nextTick(() => {
      // Wait a bit for dropdowns to load, then restore draft if available
      setTimeout(() => {
        if (this.hasFormDraft && this.isFormEmpty) {
          // Only auto-restore if form is empty
          // User can manually restore if form has data
        }
      }, 1000)
    })

    // Auto-populate drive name for Reliance clients on mount
    this.$nextTick(() => {
      if (this.isRelianceClient && !this.form.driveName && this.computedDriveName) {
        this.form.driveName = this.computedDriveName
      }
    })
  },
  computed: {
    pocState() {
      // Pure derivation only - the error message itself is kept in sync by the
      // 'form.poc' watcher below (computed getters must not have side effects).
      let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
      return this.form.poc && !regName.test(this.form.poc) ? 'Please Enter Full Name' : ''
    },
    isKPMGRPOClient() {
      return this.form.clientSelected && 
             this.form.clientSelected.title && 
             this.form.clientSelected.title.includes('KPMG RPO')
    },
    isRelianceClient() {
      return this.form.clientSelected && 
             this.form.clientSelected.title && 
             (this.form.clientSelected.title.includes('Reliance') || 
              this.form.clientSelected.title === 'Reliance RPO')
    },
    computedDriveName() {
      if (!this.isRelianceClient) return ''
      const clientName = this.form.clientSelected ? this.form.clientSelected.title : ''
      if (!clientName) return ''

      const typeMap = { 'Full Time': 'Lateral', 'Fixed Term': 'FTE' }
      const driveType = typeMap[this.form.type] || this.form.type || ''

      const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      const formattedDates = (this.form.driveDates || [])
        .filter(d => d && d.length === 10)
        .map(d => {
          const [yyyy, mm, dd] = d.split('-')
          return `${dd}-${monthNames[parseInt(mm, 10) - 1]}-${yyyy}`
        })

      const domainObj = this.form.domainSelected
      const domain = domainObj ? (domainObj.title || domainObj) : ''

      let name = driveType ? `${clientName}-${driveType}` : clientName
      if (formattedDates.length > 0) name += '-' + formattedDates.join(' / ')
      if (domain) name += '-' + domain
      return name
    },
    // form.business is bound to a single-select v-select, so its value is a plain
    // {id, title} object (not an array) once something is selected. Support both
    // shapes defensively so this doesn't silently break if that ever changes.
    hasSelectedBusiness() {
      const b = this.form.business
      if (Array.isArray(b)) return b.length > 0
      return !!(b && b.title)
    },
    filteredSubBusinessOptions() {
      if (!this.hasSelectedBusiness) {
        return []
      }
      const b = this.form.business
      const selectedBusinessIds = Array.isArray(b) ? b.map(business => String(business.id)) : [String(b.id)]
      return this.subBusinessOptions.filter(subBusiness => selectedBusinessIds.includes(String(subBusiness.abbrev)))
    },
    isAccountManager() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      return userData.role === 'account-manager'
    },
    hasFormDraft() {
      try {
        const draft = localStorage.getItem(this.formDraftKey)
        return draft !== null && draft !== ''
      } catch (error) {
        return false
      }
    },
    isFormEmpty() {
      // Check if form has meaningful data
      return !this.form.jobTitle && 
             !this.form.poc && 
             !this.form.clientSelected &&
             !this.form.domainSelected &&
             !this.form.jdContent
    }
  },
  watch: {
    'form.poc'(newVal) {
      let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
      this.error.poc = newVal && !regName.test(newVal) ? 'Please Enter Full Name' : ''
    },
    'form.clientSelected': {
      handler(newVal) {
        if (newVal && newVal.title) {
          this.loadClientDropdownData(newVal)
          // Reset dependent fields when client changes
          this.form.business = ''
          this.form.subBusiness = []
          this.form.jobFunction = null
          // Initialize driveDates for Reliance clients
          const t = newVal.title
          if (t === 'Reliance RPO' || t === 'Reliance' || t.includes('Reliance')) {
            if (!this.form.driveDates || this.form.driveDates.length === 0) {
              this.form.driveDates = ['']
            }
          }
        } else {
          // Clear options when client is deselected
          this.businessOptions = []
          this.subBusinessOptions = []
          this.jobFunctionOptions = []
        }
      },
      immediate: false
    },
    'form.driveDates': {
      deep: true,
      handler() {
        if (this.isRelianceClient && this.computedDriveName) {
          this.form.driveName = this.computedDriveName
        }
      }
    },
    'form.domainSelected'() {
      if (this.isRelianceClient && this.computedDriveName) {
        this.form.driveName = this.computedDriveName
      }
    },
    'form.type'() {
      if (this.isRelianceClient && this.computedDriveName) {
        this.form.driveName = this.computedDriveName
      }
    },
    'form.business': {
      handler(newVal, oldVal) {
        // Reset subBusiness selection when business selection changes
        if (newVal !== oldVal) {
          this.form.subBusiness = []
        }
      },
      deep: true
    },
    // Auto-save watchers
    'form': {
      handler() {
        if (this.autoSaveEnabled && !this.isRestoring) {
          this.debouncedSaveFormDraft()
        }
      },
      deep: true
    }
  },
  created() {
    var checkbox = document.querySelector("#__BVID__171")
    //document.querySelector("#__BVID__171")

    UserService.getAllRecruitersList().then(res =>{
        this.recruiters = res.data.filter(item => item.status === 'ACTIVE')
    })
    UserService.getAllManagersList().then(res =>{
      this.accountMgr = res.data.filter(item => item.status === 'ACTIVE')
    })
    // UserService.getAllUsersDd().then( res => {
    //   if(res.status === "OK") {
    //     console.log("in if", res.data)
    //     this.recruiters = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager" || item.role === "talent-advisor");
    //     // this.accountMgr = res.data.filter(item => item.role !== "talent-advisor-sourcer" && item.role !== "talent-advisor" && item.role !== "mis" && item.role !== "supervisor" && item.role !== "accountant" && item.role !== "hr" && item.status === 'ACTIVE');
    //     this.accountMgr = res.data.filter(item => item.role === 'account-manager' || item.role === 'program-manager' || item.role === 'master' || item.role === 'hr-head')
    //     console.log('Account manager: ', this.accountMgr)
    //     // const am = {
    //     //     "id": 91,
    //     //     "title": "Tarun Malhotra",
    //     //     "emp_id": "SH-094",
    //     //     "role": "master",
    //     //     "email": "tarun.malhotra@sattvahuman.com",
    //     //     "manager": "SH-003"
    //     // }
    //     // const am1 = {
    //     //     "id": 103,
    //     //     "title": "Samantha Victor",
    //     //     "emp_id": "SH-105",
    //     //     "role": "master",
    //     //     "email": "samantha.victor@sattvahuman.com",
    //     //     "manager": "SH-003"
    //     // }
    //     // const am2 = {
    //     //     "id": 25,
    //     //     "title": "Dhanya",
    //     //     "emp_id": "SH-007",
    //     //     "role": "master",
    //     //     "email": "dhanya@sattvahuman.com",
    //     //     "manager": "SH-003"
    //     // }
    //     // const am3 = {
    //     //     "id": 3,
    //     //     "title": "Yogesh Tiwari",
    //     //     "emp_id": "SH-003",
    //     //     "role": "master",
    //     //     "email": "yogesh@sattvahuman.com",
    //     //     "manager": "SH-003"
    //     // }
    //     // this.accountMgr.push(am);
    //     // this.accountMgr.push(am1);
    //     // this.accountMgr.push(am2);
    //     // this.accountMgr.push(am3);
    //     this.sourcer = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager");

    //     const srcr = {
    //         "id": 3,
    //         "title": "Yogesh Tiwari",
    //         "emp_id": "SH-003",
    //         "role": "master",
    //         "email": "yogesh@sattvahuman.com",
    //         "manager": "SH-003"
    //     }
    //     const srcr1 = {
    //         "id": 91,
    //         "title": "Tarun Malhotra",
    //         "emp_id": "SH-094",
    //         "role": "master",
    //         "email": "tarun.malhotra@sattvahuman.com",
    //         "manager": "SH-003"
    //     }
    //     this.sourcer.push(srcr);
    //     this.sourcer.push(srcr1);
    //     this.recruiters.push(srcr);
    //     this.recruiters.push(srcr1);
    //     console.log(this.recruiters)
    //     console.log(this.accountMgr)
    //     console.log(this.sourcer)
    //   }
      
    // }).then( d => {
    // console.log(this.recruiters.length, !this.recruiters.length)
    
    // })
    clientService.getClients().then(res => {
      this.clients = res.data
    })
    domainService.getDomains().then(res => {
      this.domains = res.data
    })
    locationService.getAll().then(res => {
      this.cities = res.data
    })

    var today = new Date();
    this.form.targetDate = moment().locale("en").add(30, 'days').format("YYYY-MM-DD")
    
    
  },
  beforeDestroy() {
    // Prevent the debounced auto-save from firing after the component is gone
    if (this.autoSaveDebounceTimer) {
      clearTimeout(this.autoSaveDebounceTimer)
      this.autoSaveDebounceTimer = null
    }
    if (this.dropdownsPollTimer) {
      clearInterval(this.dropdownsPollTimer)
      this.dropdownsPollTimer = null
    }
  },
  methods: {
    addDriveDate() {
      this.form.driveDates.push('')
      this.updateDriveName()
    },
    removeDriveDate(i) {
      this.form.driveDates.splice(i, 1)
      this.updateDriveName()
    },
    updateDriveName() {
      if (this.isRelianceClient) {
        this.form.driveName = this.computedDriveName
      }
    },
    loadClientDropdownData(client) {
      if (!client || !client.title) return
      // If the client has a "title" property and its value is "KPMG RPO", pass only the title string to the API call
      if (client && client.title) {
        client = client.title
      }
      adminConfigService.getClientDropdownList(client).then(res => {
        this.businessOptions = res.data.data.businessList || []
        if (res.data.data.atsCollection && Array.isArray(res.data.data.atsCollection)) {
          this.jobFunctionOptions = res.data.data.atsCollection
            .filter(item => item && item.title)
            .map(item => ({ title: item.title }))
        }
        
        // Process sub-business options to add unique keys and remove duplicates
        const rawSubBusinessOptions = res.data.data.subBusinessList || []
        const uniqueSubBusinesses = new Map()
        
        rawSubBusinessOptions.forEach((subBusiness, index) => {
          const key = `${subBusiness.abbrev}-${subBusiness.title}`
          if (!uniqueSubBusinesses.has(key)) {
            uniqueSubBusinesses.set(key, {
              ...subBusiness,
              id: index, // Add unique ID to prevent duplicate key errors
              key: key   // Add unique key for Vue
            })
          }
        })
        
        this.subBusinessOptions = Array.from(uniqueSubBusinesses.values())
      }).catch(error => {
        console.error('Error loading client dropdown data:', error)
      })
    },
    formSubmitted() {
      if(!this.$can('create','jobs')) {
        return
      }
      if(this.isSubmitting) {
        // Guard against duplicate submissions (e.g. double-click) while a request is in flight
        return
      }
      const validation = this.validationForm();
      
      if(validation) {
        this.isSubmitting = true
        const formData = new FormData()
        
        //console.log(this.form.recruitersSelected, this.form.mgrSelected)
        const cities = (this.form.citySelected || []).map(({ title }) => title).join(',');
        const rid = (this.form.recruitersSelected || []).map(({ id }) => id);
        const sid = (this.form.sourcerSelected || []).map(({ id }) => id);
        const aid = [this.form.mgrSelected.id];
        let all_id = [...rid, ...aid, ...sid]
        let uniq_id = [...new Set(all_id)];

        
        const userData = JSON.parse(localStorage.getItem('userData'));

        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
        const username = `${userData.first_name} ${userData.last_name}`
        const recruiters = JSON.stringify(this.form.recruitersSelected)
        const sourcer = JSON.stringify(this.form.sourcerSelected)
        const mgr = '[' + JSON.stringify(this.form.mgrSelected) + ']'
        const client = '[' + JSON.stringify(this.form.clientSelected) + ']'
        const domain = '[' + JSON.stringify(this.form.domainSelected) + ']'
        const business = this.form.business ? this.form.business.title || this.form.business : ''
        const subBusiness = this.form.subBusiness && this.form.subBusiness.length ? this.form.subBusiness.title || this.form.subBusiness : ''
        const jobFunction = this.form.jobFunction ? this.form.jobFunction.title || this.form.jobFunction : ''
        const driveName = this.form.driveName ? this.form.driveName : ''
        const positionSubmissionDate = this.form.positionSubmissionDate ? this.form.positionSubmissionDate : ''
        formData.append('position_name', this.form.jobTitle)
        formData.append('role', this.form.role)
        formData.append('band', this.form.jobBand)
        formData.append('client', client)
        formData.append('domain', domain)
        formData.append('business', business)
        formData.append('sub_business', subBusiness)
        formData.append('function', jobFunction)
        formData.append('drive_name', driveName)
        if (positionSubmissionDate) {
          // Backend casts this to a timestamptz column; sending '' causes
          // "invalid input syntax for type timestamp with time zone: Invalid date" (500).
          // Only send it when a real date was chosen (e.g. Reliance RPO jobs).
          formData.append('position_submission_date', positionSubmissionDate)
        }
        formData.append('no_of_vacancies', this.form.noOfPositions)
        formData.append('locations', cities)
        formData.append('target_date', this.form.targetDate)
        formData.append('min_ctc', this.form.minCTC)
        formData.append('max_ctc', this.form.maxCTC)
        formData.append('min_exp', this.form.minExp)
        formData.append('max_exp', this.form.maxExp)
        formData.append('notice_period', this.form.noticePeriod.value)
        
        formData.append('desired_skills', this.form.skills)
        //formData.append('mandatory_skills', this.form.skills)
        formData.append('job_description', this.form.jdContent)
        formData.append('poc', this.form.poc)
        formData.append('recruiters', recruiters)
        formData.append('account_mgr', mgr)
        formData.append('sourcer',sourcer)
        //formData.append('attachments', this.form.jobTitle)
        formData.append('status', 'Active')
        formData.append('created_by', user)
        formData.append('updated_by', user)
        //formData.append('notes', this.form.notes)
        formData.append('type', this.form.type)
        formData.append('payroll', this.form.payroll ? this.form.payroll : this.form.type === 'Full Time' || this.form.type === 'Fixed Term' ? 'Client Payroll' : '')
        formData.append('category', this.form.category)
        formData.append('vertical', this.form.vertical)
        if(this.checked) {
          formData.append('jdFile', this.form.file)
        }
        const accessToken = localStorage.getItem('accessToken')

        JobService.addJob(formData).then( res => {
          if(res.status === "OK") {

          
          const job_id = res.data.job_id
          const clientName = this.form.clientSelected.title
          const jobTitle = res.data.position_name;
          const noOfPositions = res.data.no_of_vacancies;
          this.id = res.data.id;
          //console.log("jobid", job_id)
          const notesData = {
            note_description: this.form.notes,
            jobId: this.id,
            recruiter_id: user
          }
            NoteService.addNote(notesData).then(res => {

              if (res.status === "OK") {
                const timelineData = {
                  title: `${job_id} - New Job Added - ${clientName} - ${jobTitle}`,
                  description: `${noOfPositions} open positions`,
                  type: "info",
                  createdBy: username,
                  jobId: this.id,
                  candidate_id: null
                }
                /*const ids = JSON.stringify({
                  "id" : all_id
                })*/
                jobTimelineService.create(timelineData).then(res => {
                  if(res.status === "OK") {
                    sendPushToUserId(uniq_id, {
                      title: `New Job assigned - ${clientName} - ${jobTitle}`,
                      body: `${noOfPositions} open positions, Click here for more details`,
                      link: buildJobDeepLink(job_id),
                      data: {
                        module: 'jobs',
                        type: 'job_assigned',
                        jobId: String(job_id),
                      },
                    }).catch(() => {})
                  } else {
                    this.form.jobId = res
                  }
                })
                //const id = JSON.parse(localStorage.getItem('userData')).id

                
                // this.$toast({
                //       component: ToastificationContent,
                //       props: {
                //         title: 'Job Created - Pending Approval',
                //         icon: 'EditIcon',
                //         variant: 'warning',
                //       },
                // })
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Job Created Successfully',
                        icon: 'EditIcon',
                        variant: 'warning',
                      },
                })
                // Clear form draft on successful submission
                this.clearFormDraft()
                 this.$router.push({ name: 'apps-jobs'})
              } else {
                this.form.jobId = res
              }
            })
          } else if ((res.status === 401 ) || (res.status === 403 )) {
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          } else if(res.status === 'FAILED') {
            this.form.jobId = res.data.message
          }
        }).catch(err => {
          console.error('Error creating job:', err)
          this.$toast({ component: ToastificationContent, props: { title: 'Something went wrong while creating the job', icon: 'AlertCircleIcon', variant: 'danger' } })
        }).finally(() => {
          this.isSubmitting = false
        })

      }
      
      
    },
    openFile (event) {
        this.form.file = event.target.files[0];
        
    },
    validationForm() {
      if (!this.form.jobTitle || this.form.jobTitle.includes('_') || this.form.jobTitle.includes(this.form.poc.split(' ')[0])) {
        
        if(!this.form.jobTitle) {
          this.error.title="Title is Mandatory"
        } else if (this.form.jobTitle.includes('_')) {
          this.error.title="Please do not use underscore in job title"
        } else if (this.form.jobTitle.includes(this.form.poc.split(' ')[0])) {
          this.error.title="Please do not enter Client Name in job title"
        }
        this.$nextTick(() => {
          this.$refs.title.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.title, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if(!this.form.type) {
        this.error.type="Position Type is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.type, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.clientSelected) {
        this.error.client="Client is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.client, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.domainSelected) {
        this.error.domain="Domain is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.domain, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.category ) {
        this.error.category="Category is Mandatory!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.category, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.business && this.isKPMGRPOClient) {
        this.error.business="Business is Mandatory!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.business, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.vertical ) {
        this.error.vertical="Vertical is Mandatory!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.vertical, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      // Validate job function for Reliance clients
      if (this.isRelianceClient && !this.form.jobFunction) {
        this.error.jobFunction="Job Function is Mandatory for Reliance clients!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.jobFunction, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (this.isRelianceClient && !this.form.driveName) {
        this.error.driveName = 'Drive Name is required for Reliance RPO jobs'
        this.$refs.driveName && this.$refs.driveName.focus()
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.driveName, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (this.isRelianceClient && !this.form.positionSubmissionDate) {
        this.error.positionSubmissionDate = 'Position Submission Date is required for Reliance RPO jobs'
        this.$refs.positionSubmissionDate && this.$refs.positionSubmissionDate.focus()
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.positionSubmissionDate, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.payroll && this.form.type === 'Contractual') {
        this.error.payroll="Payroll is Mandatory for Contractual Jobs!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.payroll, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
      if(this.form.poc && !regName.test(this.form.poc))
      {
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: 'Please enter a valid full name for Point of Contact', icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.minExp) {
        this.error.minExp="Min Exp is Mandatory"
        this.$nextTick(() => {
          this.$refs.minexp.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.minExp, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
      }
      if (!this.isValidOneDecimal(this.form.minExp)) {
        this.error.minExp = 'Enter a valid number with at most 1 decimal place (e.g. 1.5)'
        this.$nextTick(() => { this.$refs.minexp.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid experience', text: this.error.minExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.maxExp) {
        this.error.maxExp="Max Exp is Mandatory"
        this.$nextTick(() => {
          this.$refs.maxexp.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.maxExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.maxExp)) {
        this.error.maxExp = 'Enter a valid number with at most 1 decimal place (e.g. 1.5)'
        this.$nextTick(() => { this.$refs.maxexp.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid experience', text: this.error.maxExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.minCTC) {
        this.error.minCTC="Min CTC is Mandatory"
        this.$nextTick(() => {
          this.$refs.minctc.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.minCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.minCTC)) {
        this.error.minCTC = 'Enter a valid amount with at most 1 decimal place (e.g. 10.5)'
        this.$nextTick(() => { this.$refs.minctc.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid CTC', text: this.error.minCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.maxCTC) {
        this.error.maxCTC="Max CTC is Mandatory"
        this.$nextTick(() => {
          this.$refs.maxctc.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.maxCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.maxCTC)) {
        this.error.maxCTC = 'Enter a valid amount with at most 1 decimal place (e.g. 10.5)'
        this.$nextTick(() => { this.$refs.maxctc.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid CTC', text: this.error.maxCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.noticePeriod) {
        this.error.noticePeriod="Notice Period is Mandatory"
        this.$nextTick(() => {
          this.$refs.np.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.noticePeriod, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
      }
      if (!this.form.noOfPositions) {
        this.error.noOfPositions="No Of Positions is Mandatory"
        this.$nextTick(() => {
          this.$refs.nop.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.noOfPositions, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
      }
      if (!this.form.skills || !this.validateDesiredSkills()) {
        this.error.skills="Skills is Mandatory or Skill Validation Failed"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.skills, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
      }
      if (!this.form.citySelected) {
        this.error.city="City is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.city, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
      }
      if (!this.form.recruitersSelected) {
        this.error.recruiter="Recruiter is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.recruiter, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.sourcerSelected) {
        this.error.sourcer="Sourcer is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.sourcer, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.jdContent || this.form.jdContent.length < 200) {
        this.error.jd="JD is Mandatory/ Content added is not enough, please add in detail"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.jd, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      
      // Validate JD content for meaningful words, not just symbols or repeated characters
      if (!this.validateJDContent(this.form.jdContent)) {
        this.error.jd="JD content must contain meaningful words and proper sentences, not just symbols or repeated characters"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.jd, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.mgrSelected) {
        this.error.accMgr="Account Manager/TL is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.accMgr, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      //  
      if(this.checked) {
        if(!this.form.file) {
          this.error.file="JD File is mandatory"
          this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.file, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
        }
        if(this.form.file.size > 2010000) {
          this.error.file="File should not be greater than 2MB"
          this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.file, icon: 'AlertCircleIcon', variant: 'danger' } })
          return false
        }
      }
      return true
    },
    // validateDesiredSkills() {
    //   console.log('in desired skill validation')
    //   // Regular expression to match the pattern
    //   const pattern = /^(\w+(\s\w+){0,3},\s?)*(\w+(\s\w+){0,3})?$/;
    //   console.log('in desired skill validation', pattern.test(this.form.skills))
    //   return pattern.test(this.form.skills);
    // },
    sanitizeOneDecimalInput(raw) {
      if (raw === null || raw === undefined) return ''
      let s = String(raw).replace(/[^\d.]/g, '')
      if (s.startsWith('.')) s = `0${s}`
      const dotIdx = s.indexOf('.')
      if (dotIdx !== -1) {
        const intPart = s.slice(0, dotIdx)
        const decPart = s.slice(dotIdx + 1).replace(/\./g, '').slice(0, 1)
        s = `${intPart}.${decPart}`
      }
      return s
    },
    onOneDecimalInput(field, value) {
      const raw = typeof value === 'string' ? value : (value && value.target ? value.target.value : value)
      this.form[field] = this.sanitizeOneDecimalInput(raw)
      if (this.error[field]) {
        this.error[field] = ''
      }
    },
    onOneDecimalBlur(field) {
      const val = this.form[field]
      if (val === '' || val === null || val === undefined) return
      let str = String(val).trim()
      if (str.endsWith('.')) {
        str = str.slice(0, -1)
      }
      const num = parseFloat(str)
      if (Number.isNaN(num)) {
        this.form[field] = ''
        return
      }
      const truncated = Math.floor(num * 10) / 10
      this.form[field] = Number.isInteger(truncated) ? String(truncated) : truncated.toFixed(1)
    },
    isValidOneDecimal(value) {
      if (value === '' || value === null || value === undefined) return false
      return /^\d+(\.\d)?$/.test(String(value).trim())
    },
    validateDesiredSkills() {
      this.error.skills = null
      const skills = (this.form.skills || '').split(',').map(s => s.trim()).filter(s => s.length > 0)
      if (skills.length < 3) {
        this.error.skills = 'At least 3 skills required, separated by comma'
        return false
      }
      return true
    },
    validateJDContent(content) {
      if (!content || typeof content !== 'string') {
        return false;
      }
      
      // Remove HTML tags if content is from rich text editor
      const plainText = content.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      
      // Split into words and filter out empty strings
      const words = plainText.split(/\s+/).filter(word => word.length > 0);
      
      // Check if content has at least 20 words
      if (words.length < 20) {
        return false;
      }
      
      return true;
    },
    // Form persistence methods
    debouncedSaveFormDraft() {
      // Clear existing timer
      if (this.autoSaveDebounceTimer) {
        clearTimeout(this.autoSaveDebounceTimer)
      }
      
      // Set new timer
      this.autoSaveDebounceTimer = setTimeout(() => {
        this.saveFormDraft()
      }, 500) // 500ms debounce
    },
    saveFormDraft() {
      if (!this.autoSaveEnabled || this.isRestoring) {
        return
      }
      
      try {
        // Serialize form data (excluding file uploads and error messages)
        const draftData = {
          // Simple fields
          jobTitle: this.form.jobTitle,
          role: this.form.role,
          band: this.form.jobBand,
          poc: this.form.poc,
          targetDate: this.form.targetDate,
          minExp: this.form.minExp,
          maxExp: this.form.maxExp,
          minCTC: this.form.minCTC,
          maxCTC: this.form.maxCTC,
          noOfPositions: this.form.noOfPositions,
          skills: this.form.skills,
          jdContent: this.form.jdContent,
          notes: this.form.notes,
          type: this.form.type,
          category: this.form.category,
          vertical: this.form.vertical,
          payroll: this.form.payroll,
          offeredPosition: this.form.offeredPosition,
          jobFunction: this.form.jobFunction,
          driveName: this.form.driveName,
          driveDates: Array.isArray(this.form.driveDates) ? [...this.form.driveDates] : [],
          
          // Complex objects - store identifiers
          clientSelected: this.form.clientSelected ? {
            id: this.form.clientSelected.id,
            title: this.form.clientSelected.title
          } : null,
          
          domainSelected: this.form.domainSelected ? {
            id: this.form.domainSelected.id,
            title: this.form.domainSelected.title
          } : null,
          
          mgrSelected: this.form.mgrSelected ? {
            id: this.form.mgrSelected.id,
            title: this.form.mgrSelected.title,
            emp_id: this.form.mgrSelected.emp_id
          } : null,
          
          noticePeriod: this.form.noticePeriod ? {
            title: this.form.noticePeriod.title,
            value: this.form.noticePeriod.value
          } : null,
          
          // Arrays - store identifiers
          citySelected: Array.isArray(this.form.citySelected) ? 
            this.form.citySelected.map(city => ({
              id: city.id,
              title: city.title
            })) : [],
          
          recruitersSelected: Array.isArray(this.form.recruitersSelected) ?
            this.form.recruitersSelected.map(rec => ({
              id: rec.id,
              title: rec.title,
              emp_id: rec.emp_id
            })) : [],
          
          sourcerSelected: Array.isArray(this.form.sourcerSelected) ?
            this.form.sourcerSelected.map(src => ({
              id: src.id,
              title: src.title,
              emp_id: src.emp_id
            })) : [],
          
          business: this.form.business ? (this.form.business.id ? {
            id: this.form.business.id,
            title: this.form.business.title
          } : this.form.business) : null,
          
          subBusiness: Array.isArray(this.form.subBusiness) ?
            this.form.subBusiness.map(sub => ({
              id: sub.id,
              title: sub.title,
              abbrev: sub.abbrev
            })) : [],
          
          timestamp: new Date().toISOString()
        }
        
        // Save to localStorage
        localStorage.setItem(this.formDraftKey, JSON.stringify(draftData))
        this.lastSavedTimestamp = draftData.timestamp
        
      } catch (error) {
        // Handle localStorage quota exceeded or other errors
        if (error.name === 'QuotaExceededError') {
          console.warn('localStorage quota exceeded, cannot save draft')
        } else {
          console.error('Error saving form draft:', error)
        }
      }
    },
    async restoreFormDraft() {
      try {
        const draftJson = localStorage.getItem(this.formDraftKey)
        if (!draftJson) {
          return
        }
        
        const draftData = JSON.parse(draftJson)
        if (!draftData) {
          return
        }
        
        this.isRestoring = true
        
        // Wait for dropdowns to be loaded
        await this.waitForDropdowns()
        
        // Restore simple fields
        this.form.jobTitle = draftData.jobTitle || ''
        this.form.role = draftData.role || ''
        this.form.jobBand = draftData.band || ''
        this.form.poc = draftData.poc || ''
        this.form.targetDate = draftData.targetDate || ''
        this.form.minExp = draftData.minExp || ''
        this.form.maxExp = draftData.maxExp || ''
        this.form.minCTC = draftData.minCTC || ''
        this.form.maxCTC = draftData.maxCTC || ''
        this.form.noOfPositions = draftData.noOfPositions || ''
        this.form.skills = draftData.skills || ''
        this.form.jdContent = draftData.jdContent || ''
        this.form.notes = draftData.notes || ''
        this.form.type = draftData.type || ''
        this.form.category = draftData.category || ''
        this.form.vertical = draftData.vertical || ''
        this.form.payroll = draftData.payroll || ''
        this.form.offeredPosition = draftData.offeredPosition || ''
        this.form.jobFunction = draftData.jobFunction || null
        this.form.driveName = draftData.driveName || ''
        this.form.driveDates = Array.isArray(draftData.driveDates) ? draftData.driveDates : ['']
        
        // Restore complex objects
        if (draftData.clientSelected) {
          const matchedClient = this.findMatchInArray(
            this.clients,
            draftData.clientSelected,
            ['id', 'title']
          )
          if (matchedClient) {
            this.form.clientSelected = matchedClient
            // Load client dropdown data if needed
            if (matchedClient.title && (matchedClient.title.includes('KPMG RPO') || matchedClient.title.includes('Reliance'))) {
              await this.loadClientDropdownData(matchedClient)
            }
          }
        }
        
        if (draftData.domainSelected) {
          const matchedDomain = this.findMatchInArray(
            this.domains,
            draftData.domainSelected,
            ['id', 'title']
          )
          if (matchedDomain) {
            this.form.domainSelected = matchedDomain
          }
        }
        
        if (draftData.mgrSelected) {
          const matchedMgr = this.findMatchInArray(
            this.accountMgr,
            draftData.mgrSelected,
            ['id', 'emp_id', 'title']
          )
          if (matchedMgr) {
            this.form.mgrSelected = matchedMgr
          }
        }
        
        if (draftData.noticePeriod) {
          const matchedNotice = this.noticePeriod.find(np => 
            np.value === draftData.noticePeriod.value ||
            np.title === draftData.noticePeriod.title
          )
          if (matchedNotice) {
            this.form.noticePeriod = matchedNotice
          }
        }
        
        // Restore arrays
        if (Array.isArray(draftData.citySelected) && draftData.citySelected.length > 0) {
          this.form.citySelected = draftData.citySelected
            .map(cityDraft => this.findMatchInArray(this.cities, cityDraft, ['id', 'title']))
            .filter(city => city !== null)
        }
        
        if (Array.isArray(draftData.recruitersSelected) && draftData.recruitersSelected.length > 0) {
          this.form.recruitersSelected = draftData.recruitersSelected
            .map(recDraft => this.findMatchInArray(this.recruiters, recDraft, ['id', 'emp_id', 'title']))
            .filter(rec => rec !== null)
        }
        
        if (Array.isArray(draftData.sourcerSelected) && draftData.sourcerSelected.length > 0) {
          this.form.sourcerSelected = draftData.sourcerSelected
            .map(srcDraft => this.findMatchInArray(this.recruiters, srcDraft, ['id', 'emp_id', 'title']))
            .filter(src => src !== null)
        }
        
        // Restore business/sub-business (after client dropdown loads)
        if (draftData.business && this.businessOptions.length > 0) {
          const matchedBusiness = this.findMatchInArray(
            this.businessOptions,
            draftData.business,
            ['id', 'title']
          )
          if (matchedBusiness) {
            this.form.business = matchedBusiness
          }
        }
        
        if (Array.isArray(draftData.subBusiness) && draftData.subBusiness.length > 0 && this.subBusinessOptions.length > 0) {
          this.form.subBusiness = draftData.subBusiness
            .map(subDraft => this.findMatchInArray(this.subBusinessOptions, subDraft, ['id', 'title', 'abbrev']))
            .filter(sub => sub !== null)
        }
        
        this.lastSavedTimestamp = draftData.timestamp || null
        
        // Show success notification
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Form Draft Restored',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
        this.isRestoring = false
        
      } catch (error) {
        console.error('Error restoring form draft:', error)
        this.isRestoring = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to restore draft',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    clearFormDraft() {
      try {
        localStorage.removeItem(this.formDraftKey)
        this.lastSavedTimestamp = null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Draft Cleared',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Error clearing form draft:', error)
      }
    },
    toggleAutoSave() {
      if (this.autoSaveEnabled) {
        // Save immediately when enabled
        this.saveFormDraft()
      }
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const now = new Date()
      const diffMs = now - date
      const diffMins = Math.floor(diffMs / 60000)
      
      if (diffMins < 1) return 'just now'
      if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`
      const diffHours = Math.floor(diffMins / 60)
      if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`
      const diffDays = Math.floor(diffHours / 24)
      return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`
    },
    findMatchInArray(array, searchObj, fields) {
      if (!array || !Array.isArray(array) || array.length === 0) {
        return null
      }
      
      // Try exact match by id first
      if (searchObj.id) {
        const matchById = array.find(item => item.id === searchObj.id)
        if (matchById) return matchById
      }
      
      // Try match by emp_id if available
      if (searchObj.emp_id) {
        const matchByEmpId = array.find(item => item.emp_id === searchObj.emp_id)
        if (matchByEmpId) return matchByEmpId
      }
      
      // Try match by title (case-insensitive)
      if (searchObj.title) {
        const matchByTitle = array.find(item => 
          item.title && item.title.toLowerCase() === searchObj.title.toLowerCase()
        )
        if (matchByTitle) return matchByTitle
        
        // Try partial match
        const partialMatch = array.find(item => 
          item.title && (
            item.title.toLowerCase().includes(searchObj.title.toLowerCase()) ||
            searchObj.title.toLowerCase().includes(item.title.toLowerCase())
          )
        )
        if (partialMatch) return partialMatch
      }
      
      return null
    },
    waitForDropdowns() {
      return new Promise((resolve) => {
        // Wait for clients, domains, cities, recruiters, accountMgr to be loaded
        this.dropdownsPollTimer = setInterval(() => {
          if (this.clients.length > 0 && 
              this.domains.length > 0 && 
              this.cities.length > 0 && 
              this.recruiters.length > 0 && 
              this.accountMgr.length > 0) {
            clearInterval(this.dropdownsPollTimer)
            this.dropdownsPollTimer = null
            resolve()
          }
        }, 100)
        
        // Timeout after 5 seconds
        setTimeout(() => {
          if (this.dropdownsPollTimer) {
            clearInterval(this.dropdownsPollTimer)
            this.dropdownsPollTimer = null
          }
          resolve()
        }, 5000)
      })
    },
  },

}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
  .repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
